export default function fmtBytes(bytes, decimals = 2, signed=false, truncate_zeros=false) {
    if (typeof bytes !== 'undefined' && bytes !== null) {
        if (bytes === 0) return (decimals>0&&!truncate_zeros)?`0.${Array(decimals+1).join('0')} B`:'0 B';
        const unsignedBytes=Math.abs(bytes);
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(unsignedBytes) / Math.log(k));
        const sign=signed?(bytes<0?"-":""):"";
        let value=(unsignedBytes / Math.pow(k, i)).toFixed(decimals < 0 ? 0 : decimals);
        value=truncate_zeros?parseFloat(value):value;
        return `${sign}${value} ${sizes[i]}`;
    } else {
        return "";
    }
}

export function fmtBytesConcise(bytes, decimals = 1, signed=false, truncate_zeros=true) {
    const parts=fmtBytes(bytes, decimals, signed, truncate_zeros).split(' ');
    if(parts.length===2) {
        return (parts[0].length>3?parts[0].split('.')[0]:parts[0])+parts[1][0];
    } else {
        return parts[0];
    }
    
}
